import React, { useState, useCallback } from 'react';
import jsCookie from 'js-cookie';
import { useHistory } from 'react-router-dom';

const Authentication = () => {

  const history = useHistory();

  const {
    csrftoken_client = '',
    sessionid_client = ''
  } = jsCookie.get();

  const [inputs, setInputs] = useState({
    csrftoken_client,
    sessionid_client
  });

  const handleInputChange = useCallback(e => {
    const {
      target: {
        name,
        value
      }
    } = e;

    setInputs(inputs => ({
      ...inputs,
      [name]: value
    }));
  }, []);

  const handleAuthenticate = useCallback(() => {
    const {
      csrftoken_client,
      sessionid_client
    } = inputs;

    jsCookie.set('csrftoken_client', csrftoken_client);
    jsCookie.set('sessionid_client', sessionid_client);

    history.replace('/');
  }, [inputs, history]);

  return (
    <div
      className="authentication"
    >
      <div>
        <p>
          csrftoken_client: &nbsp;
        </p>
        <input
          name="csrftoken_client"
          placeholder="csrftoken_client"
          onChange={handleInputChange}
          value={inputs['csrftoken_client']}
        />
      </div>
      <div>
        <p>
          sessionid_client: &nbsp;
        </p>
        <input
          name="sessionid_client"
          placeholder="sessionid_client"
          onChange={handleInputChange}
          value={inputs['sessionid_client']}
        />
      </div>
      <button
        onClick={handleAuthenticate}
      >
        Authenticate
      </button>
    </div>
  );
};

export default Authentication;
